module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-digestive.04d57199.png";